import { ImageOptimized } from './image/ImageOptimized';
import { Link } from './Link';

type LogoProps = {
  width: number;
  height: number;
  asLink: boolean;
};

export function Logo({ width, height, asLink }: LogoProps) {
  return (
    <>
      {asLink ? (
        <Link href="/">
          <ImageOptimized
            src={'/assets/images/logo.svg'}
            width={width}
            height={height}
            alt={'BluMint Logo'}
          />
        </Link>
      ) : (
        <ImageOptimized
          src={'/assets/images/logo.svg'}
          width={width}
          height={height}
          alt={'BluMint Logo'}
        />
      )}
    </>
  );
}
